import React from 'react';
import PropTypes from 'prop-types';

import './LoginFrame.css';

const AUTH_ROOT = 'https://docker-dev-rory.dialsource.com';
const AUTH_URL = `${AUTH_ROOT}/login`;

/**
 * The LoginFrame component provides an invisible iframe which performs user authentication
 */
class LoginFrame extends React.Component {
  componentDidMount() {
    // Add the handler for receiving message data from the iframe
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    // Remove the message handler when the iframe will no longer be rendered
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (message) => {
    // TODO check iframe === source
    if (message.origin === AUTH_ROOT && message.data.source === 'ds-auth-login') {
      const auth = {
        user: {
          name: message.data.claims.name,
        },
        org: {
          name: message.data.claims.custom_attributes.org_name,
        },
      };
      console.log(auth);
      console.log('Login Success:', auth.user.name);
      console.log(message.data);
      this.props.onLogin(auth);
    }
  };

  render() {
    return (
      <iframe
        className="ds__LoginFrame"
        src={AUTH_URL}
        title="INTERNAL: LoginFrame"
      />
    );
  }
}

export default LoginFrame;

LoginFrame.propTypes = {
  onLogin: PropTypes.func.isRequired,
};
